// src/components/navigation/MobileMenu.js

import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { getAuth, signOut, onAuthStateChanged } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import LockedFeatureItem from "./LockedFeatureItem";

const navItems = [
  {
    to: "/dashboard",
    label: "Dashboard",
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
        />
      </svg>
    ),
  },
  {
    to: "/sample-orders",
    label: "Sample Orders",
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
        />
      </svg>
    ),
  },
  {
    to: "/inventory",
    label: "Inventory",
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
        />
      </svg>
    ),
  },
  {
    to: "/accounts",
    label: "Accounts",
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2a5 5 0 00-9.288-2.143M7 20H2v-2a3 3 0 015.356-1.857M12 7a3 3 0 11-6 0 3 3 0 016 0zm8 2a2 2 0 11-4 0 2 2 0 014 0z"
        />
      </svg>
    ),
  },

  // ✅ Keep Tasks (matches Sidebar)
  {
    to: "/tasks",
    label: "Tasks",
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 12l2 2 4-4m1-5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V6a2 2 0 00-2-2z"
        />
      </svg>
    ),
  },
  // ✅ NEW: Documents
  {
    to: "/documents",
    label: "Documents",
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
        />
      </svg>
    ),
  },

  {
    to: "/settings",
    label: "Profile & Company",
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
        />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
  },
  {
    to: "/team",
    label: "Team",
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2a5 5 0 00-9.288-2.143M7 20H2v-2a3 3 0 015.356-1.857M12 7a3 3 0 11-6 0 3 3 0 016 0zm8 2a2 2 0 11-4 0 2 2 0 014 0z"
        />
      </svg>
    ),
  },
];

// 🔐 Admin-only nav item
const adminNavItem = {
  to: "/admin",
  label: "Admin",
  icon: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M4 7h16M4 17h10M17 17h3M10 7a2 2 0 11-4 0 2 2 0 014 0zm8 10a2 2 0 11-4 0 2 2 0 014 0z"
      />
    </svg>
  ),
};

const MobileMenu = ({ isOpen, onClose, featureAccess = {} }) => {
  const navigate = useNavigate();
  const auth = getAuth();
  const db = getFirestore();

  const [userRole, setUserRole] = useState(null);

  // Load user role
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (firebaseUser) => {
      if (!firebaseUser) {
        setUserRole(null);
        return;
      }

      try {
        const userRef = doc(db, "users", firebaseUser.uid);
        const snap = await getDoc(userRef);
        if (snap.exists()) {
          const data = snap.data();
          setUserRole(data.role || null);
        } else {
          setUserRole(null);
        }
      } catch (err) {
        console.error("[MobileMenu] Error loading user role:", err);
        setUserRole(null);
      }
    });

    return () => unsub();
  }, [auth, db]);

  const isAdminUser = userRole === "admin" || userRole === "owner";

  const navLinkClass = ({ isActive }) =>
    [
      "flex items-center gap-3 px-3 py-3 rounded-lg text-sm font-medium transition-all duration-200",
      isActive
        ? "bg-blue-600 text-white shadow-md shadow-blue-600/20"
        : "text-gray-700 hover:bg-gray-50 hover:text-gray-900",
    ].join(" ");

  // Logout
  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/login");
    } catch (err) {
      console.error("[MobileMenu] Sign out error:", err);
      alert("Could not sign out.");
    }
  };

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  // If closed, don't render
  if (!isOpen) return null;

  // Hide mobile nav completely for customers
  if (userRole === "customer") return null;

  // Build final nav list (adds Admin item for admin/owner)
  const effectiveNavItems = isAdminUser ? [...navItems, adminNavItem] : navItems;

  return (
    <>
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/50 z-40 md:hidden" onClick={onClose} />

      {/* Slide-out menu */}
      <div className="fixed inset-y-0 left-0 w-[88vw] max-w-xs bg-white shadow-2xl z-50 md:hidden flex flex-col">
        {/* Header */}
        <div className="h-16 flex items-center justify-between px-5 border-b border-gray-100">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-2xl bg-gradient-to-br from-blue-600 to-blue-700 flex items-center justify-center shadow-md">
              <span className="text-white text-sm font-bold">SH</span>
            </div>
            <div>
              <div className="text-sm font-bold tracking-tight text-gray-900">
                TheSupplyHawk
              </div>
              <div className="text-[11px] text-gray-500 leading-tight">
                Quick access
              </div>
            </div>
          </div>

          {/* Close button */}
          <button
            onClick={onClose}
            className="p-2 -mr-2 rounded-xl hover:bg-gray-100 transition-colors"
            aria-label="Close menu"
          >
            <svg className="w-6 h-6 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Navigation links */}
        <nav className="flex-1 px-3 py-5 space-y-1.5 overflow-y-auto">
          {effectiveNavItems.map((item) => {
            const featureKey = item.to === "/orders"
              ? "orders"
              : item.to === "/territories-map"
                ? "map"
                : null;
            const access = featureKey ? featureAccess?.[featureKey] : null;
            if (access?.reason === "hidden_entirely") {
              return null;
            }
            const locked = !!access && access.allowed === false;

            if (locked) {
              return (
                <LockedFeatureItem
                  key={item.to}
                  label={item.label}
                  icon={item.icon}
                  message={access?.lockMessage || (access?.reason === "paid_only" ? "Paid plan required" : "Hidden by developer")}
                  className="flex w-full items-center gap-3 rounded-lg border border-gray-200 bg-gray-50 px-3 py-3 text-left text-sm font-medium text-gray-400"
                  iconClassName="text-gray-400"
                  labelClassName="flex-1"
                  lockClassName="h-4 w-4"
                  bubbleClassName="w-64"
                />
              );
            }

            return (
              <NavLink key={item.to} to={item.to} onClick={onClose} className={navLinkClass}>
                {({ isActive }) => (
                  <>
                    <span className={isActive ? "text-white" : "text-gray-400"}>
                      {item.icon}
                    </span>
                    <span>{item.label}</span>
                  </>
                )}
              </NavLink>
            );
          })}
        </nav>

        {/* Logout Button */}
        <div className="px-3 py-2 border-t border-gray-100">
          <button
            onClick={() => {
              handleLogout();
              onClose();
            }}
            className="flex items-center gap-3 w-full px-3 py-3 rounded-2xl text-sm font-medium text-gray-700 hover:bg-red-50 hover:text-red-700 transition-all duration-200"
          >
            <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
              />
            </svg>
            <span>Logout</span>
          </button>
        </div>

        {/* Footer */}
        <div className="px-5 py-4 border-t border-gray-100">
          <div className="text-[11px] text-gray-400 leading-relaxed">
            © {new Date().getFullYear()} TheSupplyHawk
            <br />
            All rights reserved
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileMenu;
